'use client';

import { type PropsWithChildren, useEffect } from 'react';

import { useGuest } from '@/app/_hooks/useGuest';
import { useAuthStore } from '@/stores/AuthStore';

export const GuestProvider = ({ children }: PropsWithChildren) => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const { setGuestSessionId, getGuestSessionId, removeGuestSessionId } =
    useGuest();

  useEffect(() => {
    //* 로딩 중 일 경우 무시
    if (isLogin === undefined) return;

    //* 로그인 상태일 경우 비회원 세션 제거
    if (isLogin) {
      removeGuestSessionId();

      return;
    }

    //* 비회원 세션이 존재할 경우 무시
    if (getGuestSessionId()) return;

    //* 비회원 세션 생성
    setGuestSessionId();
  }, [getGuestSessionId, isLogin, removeGuestSessionId, setGuestSessionId]);

  return <>{children}</>;
};
